import React from "react";
import {
  Box,
  Heading,
  Image,
  Text,

  
} from "@chakra-ui/react";

// Image imports
import yellowCard from "../../../assets/home/phonecard1.png"; // Yellow tag image
import flowerImage from "../../../assets/home/flowerr.png"; // Decorative flower image behind heading
import DesignCards from "./DiscoverDesign/DesignCards";


const Discover = () => {
  return (
    <Box bg="#F9E8D4" py={{ base: 10, md: 20 }} px={{ base: 4, md: 16 }} position="relative">
      {/* Yellow tag image */}
      <Image
        src={yellowCard}
        alt="Yellow tag"
        position="absolute"
        top={{ base: "0", md: "6" }}
        right={{ base: "0", md: "24%" }}
        w={{ base: "120px", md: "160px" }}
      
        zIndex={2}
      />

      {/* Heading with flower behind */}
      <Box textAlign="center" mb={10} position="relative">
        {/* Flower image behind heading */}
        <Image
          src={flowerImage}
          alt="Flower"
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          boxSize={{ base: "80px", md: "140px" }}
          opacity={1}
          zIndex={0}
          
          
        />

        <Heading
          as="h2"
          fontSize={{ base: "2xl", md: "4xl" }}
          fontWeight="bold"
          zIndex={1}
          position="relative"
          className="fade-in-up"
        >
          Discover Hamare{" "}
          <Text as="span" fontStyle="italic" color="gray.600" className="fade-in-up">
            Best Designs
          </Text>
          ,
        </Heading>
      </Box>

      {/* Cards Section */}
     <DesignCards/>
    </Box>
  );
};

export default Discover;
